import {createReducer} from '@reduxjs/toolkit';
import {increment, decrement} from '../actions/counter';

export interface CounterState {
  count: number;
}

function incrementCounter(state: CounterState): CounterState {
  return {
    count: state.count + 1,
  };
}

function decrementCounter(state: CounterState): CounterState {
  return {
    count: state.count - 1,
  };
}

export const counterReducer = createReducer<CounterState>({count: 0}, (builder) => {
  builder.addCase(increment, incrementCounter).addCase(decrement, decrementCounter);
});
